import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import "./index.css";
import successModalImage from "../../../../../images/new-images/modal-image.png";
import { Link } from "react-router-dom";

const Rendersuccessmodal = (props) => {
 const RequirementParticipant= localStorage.getItem('is_auth_participant');
 if(props.nestedModal){
  localStorage.setItem('assessment_done',true)
 }else{
  localStorage.setItem('assessment_done',true)
 }
 
  return (
    <Modal isOpen={props.nestedModal} centered={true} className="submitModal">
      <ModalBody>
        <h1 className="success-message">{props.modalSuccessMessage}</h1>
        <img src={successModalImage} />
        <h2>{props.modalText}</h2>
        <p>{props.requestText}</p>
      </ModalBody>
      {RequirementParticipant==='true'?     <ModalFooter>
      <Link
            to={{
              pathname: `/assessment-expired`,
            }}
          >
            <Button className="next-button">Close</Button>
          </Link>
  
      </ModalFooter>:
      <ModalFooter>
        {props.assessmentType == "invitations" ? (
          <Link
            to={{
              pathname: `/new/app/dashBoard`,
            }}
          >
            <Button className="next-button">{props.submitButtonText}</Button>
          </Link>
        ) : props.reviewMode == true &&
          (props.isMultiRater == false ||
            props.submitAssessmentReport == "submitAssessment") ? (
          <Link
            style={{ width: "35%" }}
            to={{
              pathname: `/new/app/dashBoard`,
            }}
          >
            <Button className="next-button">{props.submitButtonText}</Button>
          </Link>
        ) : props.instrumentType == "LOI-Self" ||
          props.instrumentType == "VVI" ||
          props.submitAssessmentReport == "submitAssessment" ? (
          <Link
            style={{ width: "35%" }}
            to={{
              pathname: `/new/app/dashBoard`,
            }}
          >
            <Button className="next-button">{props.submitButtonText}</Button>
          </Link>
        ) : props.reviewMode == true ? (
          <Link
            style={{ width: "35%" }}
            to={{
              pathname: `/new/app/completedassessment/${props.uid}/${props.participantId}/${props.isMultiRater}/${props.min_batch_respondents}`,
            }}
          >
            <Button className="next-button">{props.submitButtonText}</Button>
          </Link>
        ) : (
          <Link
            to={{
              pathname: `/new/app/completedassessment/${props.uid}/${props.participantId}/${props.isMultiRater}/${props.min_batch_respondents}`,
            }}
          >
            <Button className="next-button">{props.submitButtonText}</Button>
          </Link>
        )}
      </ModalFooter>
}
    </Modal>
  );
};
export default Rendersuccessmodal;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/submit-assessment-modal/success-modal.jsx